<h2 mat-dialog-title>
  <mat-icon svgIcon="avatar" aria-hidden="false" aria-label="Bruger"></mat-icon>
  Tilknyt brikinformation
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<form [formGroup]="userFormGroup" (ngSubmit)="save()">
  <mat-dialog-content>
    <div class="form-row">
      <h2 class="form-headline">Har brugeren firmabil?</h2>
      <mat-radio-group formControlName="userHaveOrganizationCar" name="userHaveOrganizationCar" class="padding--top-none">
        <mat-radio-button [value]="true">
          <span>Ja</span>
        </mat-radio-button>
        <mat-radio-button [value]="false">
          <span>Nej</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>
    @if (userFormGroup.controls.userHaveOrganizationCar.value) {
      <div class="form-row">
        <div>
          <adm-g4-agreement-number [control]="userFormGroup.controls.agreementNumber" />
          <mat-hint class="tiny-text">
            Indtastet aftalenr bliver brugt til at fakturere alt forbrug for brikkerne tilknyttet brugeren
          </mat-hint>
        </div>
      </div>
    } @else {
      <div class="form-row">
        <div>
          <adm-g4-account-number [control]="userFormGroup.controls.invoicingAccountNumber" />
          <mat-hint class="tiny-text">
            Indtastet kontonr. bliver brugt til at fakturere alt forbrug for brikkerne tilknyttet brugeren
          </mat-hint>
        </div>
      </div>
    }
    <div class="form-row">
      <mat-form-field>
        <mat-label>Leveringsadresse</mat-label>
        <input
          type="text"
          required=""
          placeholder="Påbegynd indtastning"
          matInput
          [matAutocomplete]="auto"
          formControlName="addressLookup"
          (blur)="emptyAddress()" />
        @if (userFormGroup.controls.addressLookup.hasError('required')) {
          <mat-error>Adresse er påkrævet.</mat-error>
        }
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectAddress($event.option.value)" okCustomDropDownArrowDirective>
          @for (address of filteredAddresses; track address) {
            <mat-option [value]="address">
              {{ formatAddressToString(address) }}
            </mat-option>
          }
        </mat-autocomplete>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-stroked-button mat-dialog-close>Annuller</button>
    @if (userFormGroup) {
      <button class="actions__button" type="submit" mat-flat-button color="primary" [disabled]="!userFormGroup.valid">Gem</button>
    }
  </mat-dialog-actions>
</form>
